<div class="mb-3" style="position: relative; width: 100%;" [class.wms-pending]="showWmsWarning()">
	<input
		[name]="'input' + name"
		type="text"
		class="form-control"
		style="width: 100%;"
		[ngModel]="displayString(model)"
		[ngClass]="classes()"
		readonly
		inert
	/>
	<span *ngIf="showWmsWarning()" class="wms-indicator" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);" title="Wird online automatisch ermittelt">
		<i class="bi bi-cloud-slash"></i>
	</span>
</div>
